import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=3f3865e2&scoped=true&"
import script from "./CompanyForm.vue?vue&type=script&lang=ts&"
export * from "./CompanyForm.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=3f3865e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3865e2",
  null
  
)

export default component.exports